import React, { useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Sidebar from "../Common/Sidebar";
import { Box, Drawer } from "@mui/material";
import { styled } from "@mui/material/styles";
import GroupIcon from "@mui/icons-material/Group"
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import CreateTenantModal from "../Dashboard/CreateTenantModal";
import Header from "../Common/Header";
import { createTenant } from "../../features/createTenant/createTenantAction";
import { getTenantDetail } from "../../features/tenantDetail/tenantDetailAction";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const drawerWidth = 240;

const MiniDrawer = styled((props) => <Drawer {...props} />)(({ theme, open }) => ({
  width: open ? drawerWidth : 72,
  flexShrink: 0,
  whiteSpace: "nowrap",
  overflowX: "hidden",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  "& .MuiDrawer-paper": {
    width: open ? drawerWidth : 72,
    gap: open ? 0 : 8,
    backgroundColor: '#1976d2',
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
}));

const AppLayout = () => {
    const [openDrawer, setOpenDrawer] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    const [tenantName, setTenantName] = useState("");
    const [domainName, setDomainName] = useState("");
    const [noOfLicenses, setNoOfLicenses] = useState(25);
    const [tenantStatus, setTenantStatus] = useState("Active");
    const [expirationDate, setExpirationDate] = useState("");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const navigationItems = [
        { 
            text: "Customers", 
            icon: <GroupIcon sx={{color: 'white', cursor: 'pointer'}} />, 
            onClick: () => navigate("/dashboard"), 
            isActive: location.pathname.includes("/customer") || location.pathname.includes("/dashboard")
        },
        { 
            text: "Courses", 
            icon: <LibraryBooksIcon sx={{color: 'white', cursor: 'pointer'}} />, 
            onClick: () => navigate("/courses"), 
            isActive: location.pathname.includes("/courses")
        },
    ];

    const toggleDrawer = () => {
        setOpenDrawer(!openDrawer);
    };

    const handleLogout = () => {
      localStorage.clear();
      dispatch({ type: "RESET_STATE" }); 
      navigate("/login", {replace: true});
    };

    const handleCreateTenant = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
      setOpenModal(false);
    };
    
    const handleAddTenant = () => {      
      if (tenantName.trim() && expirationDate.trim()) {
        const newTenant = {
          tenant: tenantName,
          status: tenantStatus === "Active" ? "Approved" : tenantStatus,
          expiry: expirationDate,
          domain: domainName,
          tenantStatus: tenantStatus === "Active" ? "Approved" : tenantStatus,
          noOfLicenses: parseInt(noOfLicenses) || 0,
        };
        dispatch(createTenant(newTenant)).then((res) => {
          if(res.payload && res.payload.data) {
            dispatch(getTenantDetail());
            toast.success(res.payload.message || "Customer added successfully!");
          } else if (res.error) {
            toast.error(res.error.message || "Unable to add customer. Please try again later.");
          }
        })
        .catch((err) => {
          toast.error(err.message || "An unexpected error occurred!");
        });
        setOpenModal(false);
        setTenantName("");
        setDomainName("");
        setTenantStatus("Active");
        setExpirationDate("");
        setNoOfLicenses("");
      }
    };

  return (
    <Box>
        <Sidebar navigationItems={navigationItems.map(item => ({ ...item, style: item.isActive ? { background: '#5186D2', color: 'white', cursor: 'pointer' } : { background: 'transparent', color: 'white', cursor: 'pointer' } }))} 
          MiniDrawer={MiniDrawer} toggleDrawer={toggleDrawer} openDrawer={openDrawer} handleLogout={handleLogout} handleCreateTenant={handleCreateTenant} />
          <Header openDrawer= {openDrawer} handleCreateTenant={handleCreateTenant} handleLogout= {handleLogout} />
          <CreateTenantModal tenantStatus={tenantStatus} setTenantStatus={setTenantStatus} setExpirationDate={setExpirationDate} openModal={openModal} handleCloseModal={handleCloseModal} handleAddTenant={handleAddTenant} tenantName={tenantName} setTenantName={setTenantName} domainName={domainName} setDomainName={setDomainName} expirationDate={expirationDate} noOfLicenses={noOfLicenses} setNoOfLicenses={setNoOfLicenses}/>
          <Box sx={{ transition: "all 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms", width: openDrawer ? "calc(100% - 240px)" : "calc(100% - 72px)", marginLeft: openDrawer ? "240px" : "72px",  padding: "20px"}}>
            <Outlet />
        </Box>
        <ToastContainer /> 
    </Box>
    
  );
}

export default AppLayout;